import React from 'react';
import {createPortal} from 'react-dom';
import {view} from '@sail/ui';
import {animate} from '@sail/engine';
import {
  useIsTopOverlay,
  useOverlayContainer,
} from '../../context/overlay/OverlayContext';

type InlineProps = {
  dataTestId?: string;
};

/**
 * InlineOverlay is an implementation of overlay that simply renders the content specified inline.
 * Similar to `Dialog`, we don't stack the content, instead only rendering the top level `InlineOverlay`
 */
export const InlineOverlay: React.FC<InlineProps> = ({
  children,
  dataTestId,
}): JSX.Element | null => {
  const container = useOverlayContainer();
  const isTopOverlay = useIsTopOverlay();
  const contents = (
    <view.div
      hidden={!isTopOverlay}
      aria-hidden={!isTopOverlay}
      uses={[
        animate.inout({
          duration: 150,
          opacity: 0,
          easing: 'ease-in-out',
        }),
      ]}
      data-testid={dataTestId}
    >
      {children}
    </view.div>
  );

  if (!container) {
    return null;
  }
  return createPortal(contents, container);
};
